import classNames from "classnames";
import { Menu } from "../../models/Menu";
import { replaceVariable } from "../../utils/string";
import { DComponent } from "../DComponent";
import { LocalStorage } from "../../models/LocalStorage";
import { ROOT_GLOBAL } from "../../global/root";
import { MINI_APP } from "../../utils/miniApp";
import Env from "../../environments";
import { urlFullFill } from "../../utils/url";
import { getCookie } from "../../utils/browser";
import { GLOBAL_CONSTANTS } from "../../global/constants";
import { DCStatic } from "../../models/DCStatic";
import { EVENTS, listenEvent } from "../../utils/event";

export default class MenuSubCollapse extends DComponent {
  constructor({
    parent,
    id,
    idMenu,
    parentItem,
    menuItems = [],
    isAutoOpen = false,
    onClose,
    onShow = () => { },
    onHide = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("MenuSubCollapse", {
        "is-main": !parentItem,
        "is-sub": parentItem
      }),
    }, true);
    /** @type {[Menu]} */
    this.menuItems = menuItems;
    this.isAutoOpen = isAutoOpen;
    this.onClose = onClose;
    this.onShow = onShow;
    this.onHide = onHide;
    /** @type {[MenuSubCollapse]} */
    this.subMenu = [];
    this.idMenu = idMenu;
    /** @type {Menu} */
    this.parentItem = parentItem;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "MenuSubCollapse");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {

    if (this.isAutoOpen) {
      this.on();
      this.show();
    }

    let root = window.location.pathname;
    this.menuItems.forEach(menu => {
      let itemHtml = "", classElement = "";
      if (!menu.hide) {
        classElement = (menu.isComingSoon ? " coming-soon" : "") + (menu.requireLogin ? " required-loggedin" : "") + (root.includes(menu.href) ? " active" : "") + (menu.className ? " " + menu.className : "");
        if (menu.isRedirect) {
          itemHtml = replaceVariable(require("html-loader!./itemRedirect.html"), {
            id: menu.id,
            class: classElement,
            href: menu.href || "",
            icon: menu.icon || "",
            iconClass: !menu.icon ? " hide" : "",
            label: menu.label,
            follow: menu.isDofollow ? "dofollow" : "nofollow",
            country: menu.country ? `country="${menu.country}"` : "",
            locale: menu.lang ? `lang="${menu.lang}"` : "",
          })
        } else {
          itemHtml = replaceVariable(require("html-loader!./item.html"), {
            id: menu.id,
            class: classElement,
            icon: menu.icon || "",
            iconClass: !menu.icon ? " hide" : "",
            label: menu.label,
            country: menu.country ? `country="${menu.country}"` : "",
            locale: menu.lang ? `lang="${menu.lang}"` : "",
          })
        }
      }
      $(".sub-menu-list", this.element).append(itemHtml);
    });

    $(".sub-menu-list > .menu-item > .menu-item-box > a", this.element).on("click", (e) => {
      if (LocalStorage.isMiniApp() && !LocalStorage.isOldApp()) {
        e.preventDefault();
        MINI_APP.openPage({ url: urlFullFill($(e.currentTarget).attr("href")) });
      }
    });

    this.menuItems.forEach(menu => {
      if (menu.subMenu?.length) {
        this.subMenu.push(new MenuSubCollapse({
          parent: $(this.parent),
          menuItems: Menu.fromApiArray(menu.subMenu),
          parentItem: menu,
          idMenu: menu.id,
          onHide: () => {
            typeof this.onHide == "function" && this.onHide();
            this.hide();
          },
          onShow: () => {
            typeof this.onShow == "function" && this.onShow();
          },
        }))
      }
      $(`.menu-item#${menu.id}`, this.element).on("click", (e) => {
        if (menu.onClick && typeof menu.onClick === "function") {
          menu.onClick();
        } else {
          const id = $(e.currentTarget).attr("id");
          let item = this.subMenu.find(item => item.idMenu === id);
          if (item) item.show();
        }
        if (menu?.closeMenu && !LocalStorage.isMiniApp()) {
          let newURl = new URL(window.location.origin + menu.href);
          if (newURl.pathname === window.location.pathname) {
            typeof this.onHide == "function" && this.onHide();
            this.hide();
          }
        }
      })
    })

    if (this.parentItem) {
      $(".sub-menu-header .sub-title", this.element).text($.i18n(this.parentItem.label));
      $(".sub-menu-header .sub-title", this.element).attr("data-i18n", this.parentItem.label);
      $(".sub-menu-header .sub-back", this.element).on("click", () => {
        this.hide();
      })
    }

    $(".close-collapse", this.element).on("click", (e) => {
      if (LocalStorage.isMiniApp() && !LocalStorage.isOldApp()) {
        MINI_APP.pop();
        return;
      }
      if (this.onClose && typeof this.onClose === "function") {
        this.onClose();
      } else {
        this.hide(true);
      }
    });

    $(".logout-item .logout-label", this.element).on("click", (e) => {
      if (LocalStorage.isMiniApp()) {
        LocalStorage.setLoginInfo();
        MINI_APP.logout();
        return;
      }
      LocalStorage.logout(ROOT_GLOBAL.HOME_PAGE);
    });
    let version = getCookie(GLOBAL_CONSTANTS.COOKIE.VERSION) || Env.DUTY_CAST_BUILD_APP_VERSION || "";
    if (version) {
      version = version.replace("dutycast-frontend-v", "").replace("dutycast-mobile-v", "");
      $(".logout-item .version .value", this.element).text(version);
      $(".logout-item .version", this.element).removeClass("hide");
    }

    this.setClass();

    listenEvent(EVENTS.CHANGE_LANGUAGE, (data) => {
      this.setClass({ lang: data });
    })

    listenEvent(EVENTS.CHANGE_COUNTRY, (data) => {
      this.setClass({ country: data });
    })

    listenEvent(EVENTS.CHANGE_AUTH_STATUS, () => {
      this.setClass();
    });
  }

  on() {
    DCStatic.userBox.changeParent($(".user-box-mobile", this.element));
    DCStatic.groupPicker.changeParent($(".group-picker-mobile", this.element));
  }

  setClass({ isLoggedIn = LocalStorage.isLoggedIn(), country = LocalStorage.getShipping(), lang = LocalStorage.getLanguage() } = {}) {
    let isCollaborator = LocalStorage.isCollaborator();
    $(".user-box-mobile", this.element).addClass(isLoggedIn ? "loggedin" : "unloggedin");
    $(`.menu-item`, this.element).each((i, obj) => {
      let c = $(obj).attr("country");
      let l = $(obj).attr("lang");
      let loggedin = $(obj).hasClass("required-loggedin");
      let collaborator = $(obj).hasClass("collaborator");
      let nocollaborator = $(obj).hasClass("none-collaborator");

      if (loggedin && !isLoggedIn) {
        $(obj).addClass("hide");
        return;
      }

      if (collaborator && !isCollaborator) {
        $(obj).addClass("hide");
        return;
      }

      if (nocollaborator && isCollaborator) {
        $(obj).addClass("hide");
        return;
      }

      if (c && c !== country) {
        $(obj).addClass("hide");
        return;
      }

      if (l && l !== lang) {
        $(obj).addClass("hide");
        return;
      }

      $(obj).removeClass("hide");
    })
  }

  show() {
    this.element.addClass("active");
    typeof this.onShow == "function" && this.onShow();
  }

  hide(isParent) {
    if (isParent) {
      $("html, body").css("overflow", "auto");
      this.subMenu?.length && this.subMenu.forEach(item => {
        item.hide();
      })
    }
    this.element.removeClass("active");
  }

  isShow() {
    return this.element ? this.element?.hasClass("active") : false;
  }
}